@if (currentProfile(); as currentProfile) {
  @if (currentProfile.isLoggedIn) {
    <div class="checkout-switch-profile">
      <h2 class="checkout-switch-profile-label text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">
        покупатель
      </h2>

      <sd-dropdown #dropdown class="checkout-switch-profile-dropdown">
        <ng-template #dropdownToggler>
          <sd-dropdown-toggler
            (click)="dropdown.toggle()"
            class="checkout-switch-profile-dropdown-toggler text-b3-s-300 color-black"
          >
            <span>
              {{ currentProfile.fullName }}
            </span>
          </sd-dropdown-toggler>
        </ng-template>

        <ng-template #dropdownContent>
          <sd-dropdown-menu (click)="dropdown.close()" class="checkout-switch-profile-dropdown-menu">
            @if (currentProfile.user?.name; as userName) {
              <sd-dropdown-menu-item
                [isActive]="!currentProfile.isLegal"
                class="checkout-switch-profile-dropdown-menu-item"
                (click)="resetCompany()"
              >
                <span>
                  {{ userName }}
                </span>
              </sd-dropdown-menu-item>
            }

            @for (item of currentProfile.companies; track item.uid) {
              <sd-dropdown-menu-item
                [isActive]="currentProfile.isLegal && currentProfile.selectedCompanyUid === item.uid"
                class="checkout-switch-profile-dropdown-menu-item"
                (click)="selectCompany(item.uid)"
              >
                <span>
                  {{ item.name }}
                </span>
              </sd-dropdown-menu-item>
            }

            <sd-add-company-button size="xs" class="checkout-switch-profile-dropdown-menu-item"></sd-add-company-button>
          </sd-dropdown-menu>
        </ng-template>
      </sd-dropdown>
    </div>
  }
}
